import React, { useEffect, useRef, useState } from 'react'
import styles from './LiveGame.module.css'
import Odd from './Odd'
import { LiveChampionships, Lives, LiveOdds } from '../types'
import { useDispatch, useSelector } from 'react-redux'
import { fetchLiveChampionships, fetchLiveSportTypes, openLiveGame, postToggleFavoriteGame, selectCurrentSportType, setFavorite, setOddsScroll } from '../LiveSlice'
import { RootState } from '../../../app/store'
import { fetchSelectedOdds } from '../LiveSlice'
import useTranslation from '../../../hooks/translations'
import { FAVORITES_SPORTTYPE } from '../../../app/const'
import { postShowSuspendedPositionErrorMessage } from '../../../api/live'
import { RESULTS_WITH_THREE_ODDS_TYPES } from '../../../app/const'
interface Props extends Lives {
  championshipId: number
  sportTypeId: number
}
const LiveGame = ({
  Id,
  fav,
  t1,
  t2,
  r1,
  r2,
  time,
  plusses,
  Odds,
  oddCount,
  status,
  stream,
  ar,
  championshipId,
  sportTypeId,
  additionalResults,
}: Props) => {
  const dispatch = useDispatch()
  const isFavorite = useSelector(
    (state: RootState) => state.liveGames.favorites
  ).includes(Id)
  const selectedOdds = useSelector((state: RootState) => state.liveGames.selectedOdds)
  const gameClick = (gameId: number) => { dispatch(openLiveGame({ gameId, sportTypeId })) }
  const oddsScroll = useSelector((state: RootState) => state.liveGames.oddsScroll)

  const favoriteClick = (gameId: number) => { 
    dispatch(postToggleFavoriteGame(gameId))
  }

  const { t } = useTranslation('live')
  const oddsRef = useRef() as React.MutableRefObject<HTMLDivElement>

  useEffect(() => {
    if (oddsRef?.current && oddsScroll[Id]) {
      oddsRef.current.scrollTo(oddsScroll[Id], 0)
    }
  }, [])

  // const onOddsClick = () => {
  //   if (!Odds?.length) postShowSuspendedPositionErrorMessage()
  // }

  const onOddScroll = () => {
    const scroll = oddsRef?.current.scrollLeft
    if(oddsScroll[Id] !== scroll) {
      dispatch(setOddsScroll({gameId: Id, scroll }))
    }
  }

  return (
    <div
      className={`${styles.game} 
                ${oddCount === '3' ? styles.withThreeodd : styles.withTwoOdd}
                ${
                  RESULTS_WITH_THREE_ODDS_TYPES.includes(sportTypeId)
                    ? styles.resultsWithThreeodd
                    : styles.resultsWithTwoOdd
                }
                ${status === 'not' ? styles.notStarted : ''}`}
      onClick={() => gameClick(Id)}
    >
      <a
        onClick={(e: React.MouseEvent<HTMLAnchorElement>): void => {
          e.stopPropagation()
          favoriteClick(Id)
        }}
        className={`${styles.favorite} ${
          isFavorite ? styles.activeFavorite : ''
        }`}
      ></a>
      <div className={styles.team1}>{t1}</div>
      <div className={styles.team2}>{t2}</div>
      {status === 'not' ? (
        <>
          {stream === 'liveStream' ? (
            <div className={styles.notStartedStream}></div>
          ) : (
            ''
          )}
          <div className={styles.startTime}>{time}</div>
          <div className={styles.notStartedTitle}>
            {t('mobile.livegame.notstarted')}
          </div>
        </>
      ) : (
        <>
          <div className={styles.additionalInfo}>
            {time}
            <span className={styles.pluses}> +{plusses} </span>
            {stream === 'liveStream' ? (
              <span className={styles.streamIcon}></span>
            ) : (
              ''
            )}
          </div>
          <div className={styles.resultContainer}>
            {additionalResults && ar ? (
              <div className={styles.additionalResults}>
                <div className={styles.resultPoint}>
                  <div
                    className={`${styles.team1ResultPoint} ${
                      ar?.turn1 === 'team-turn' ? styles.teamTurn : ''
                    }`}
                  >
                    {ar?.point1}
                  </div>
                  <div
                    className={`${styles.team2ResultPoint} ${
                      ar?.turn2 === 'team-turn' ? styles.teamTurn : ''
                    }`}
                  >
                    {ar?.point2}
                  </div>
                  <div className={styles.resultPointTitle}>
                    {t('live.result.point.title')}
                  </div>
                </div>
                <div className={styles.resultGame}>
                  <div className={styles.team1ResultGame}>{ar?.game1}</div>
                  <div className={styles.team2ResultGame}>{ar?.game2}</div>
                  <div className={styles.resultGameTitle}>
                    {t('live.result.game.title')}
                  </div>
                </div>
              </div>
            ) : (
              ''
            )}
            <div className={styles.team1Result}>{r1}</div>
            <div className={styles.team2Result}>{r2}</div>
            {additionalResults ? (
              <div className={styles.resultTitle}>{t('live.result.title')}</div>
            ) : (
              ''
            )}
          </div>
          <div
            ref={oddsRef}
            onScroll={onOddScroll}
            onClick={(e: React.MouseEvent<HTMLDivElement>): void => {
              e.stopPropagation()
              //onOddsClick()
            }}
            className={Odds.length ? styles.odds : styles.emptyOdds}
          >
            {Odds.length
              ? Odds.map((odd: LiveOdds) => {
                  return (
                    <Odd
                      key={odd.Id}
                      Id={odd.Id}
                      type={odd.type}
                      active={odd.active}
                      paused={odd.paused}
                      snatch={odd.snatch}
                      title={odd.title}
                      gameId={Id}
                      championshipId={championshipId}
                      isActive={selectedOdds.includes(Number(odd.Id))}
                    />
                  )
                })
              : ''}
          </div>
          <div className={styles.livePulse}></div>
        </>
      )}
    </div>
  )
}

export default React.memo(LiveGame)